import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClear = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "circle-remove" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Symbols",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Artboard",
				fill: "currentColor",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("g", {
					id: "circle-remove",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M8,0 C3.6,0 0,3.6 0,8 C0,12.4 3.6,16 8,16 C12.4,16 16,12.4 16,8 C16,3.6 12.4,0 8,0 Z M11.5,10.1 L10.1,11.5 L8,9.4 L5.9,11.5 L4.5,10.1 L6.6,8 L4.5,5.9 L5.9,4.5 L8,6.6 L10.1,4.5 L11.5,5.9 L9.4,8 L11.5,10.1 Z",
						id: "Shape"
					})
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgClear);
export default ForwardRef;
